<template>
  <div class="cdu-header-component">
    <div class="clock">
      <span v-if="(brand_white1 || brand_translux5)" class="date">
        {{(new Date()) | moment(dateFormats.dayAndMonthInverse) }}
      </span>
      <span v-else-if="brand_translux3" class="date">
        {{ (new Date()) | moment(dateFormats.dayMonthAndYear) }}
      </span>
      <span v-else class="date">
        {{ (new Date()) | moment(dateFormats.dayAndMonth) }}
      </span>
      <span class="time">
        {{(new Date()) | moment(dateFormats.shortTime) }}
        <span class="time-suffix">
          {{ (new Date()) | moment('A') }}
        </span>
      </span>
    </div>
    <img class="logo" src="static/img/logo.png" alt="Logo">


    <span class="live-icon" v-if="(brand_white1 || brand_translux5) && screenConfiguration.is2showeventsin2columns && liveEventAppearsOnScreen">LIVE</span>
    <span class="sport-icons" v-if="(brand_white1 || brand_translux5) && screenConfiguration.is2showeventsin2columns && screenIdFoSportTypes.length === 1">
      <sport-icon :event="cduNonPinnedEvents"></sport-icon>
    </span>
    <span class="screen-message text-overflow" v-html="screenConfiguration.topmarketinglinetext"></span>

    <span v-if="currentRotateIndex !== undefined && maxRotationIndex !== undefined" class="paging-index">PAGE {{ currentRotateIndex + 1 }} of {{ maxRotationIndex + 1 }}</span>
    <div v-if="isDebug" class="debug">

    </div>
  </div>
</template>

<script>
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Brands from '@/components/mixins/Brands'
  import store from '@/store'

  import Icon from '@/components/common/Icon'
  import SportIcon from '@/components/common/SportIcon'

  export default {
    name: 'cdu-header',

    mixins: [
      BettingOffer,
      Brands
    ],

    components: {
      Icon,
      SportIcon
    },

    data () {
      return {
      }
    },

    computed: {
      logoScr () {
        if (this.clientName === 'default') {
          return '/static/img/logo.png'
        } else {
          return `/static/img/${this.clientName}.png`
        }
      },
      maxRotationIndex () {
        return store.getters['bettingOfferState/getMaxRotationIndex']
      },
      currentRotateIndex () {
        return store.getters['bettingOfferState/getCurrentRotateIndex']
      },
      cduNonPinnedEvents () {
        return store.getters['bettingOfferState/getCduNonPinnedEvents']
      },
      screenIdFoSportTypes () {
        var idfosporttypes = []
        this.cduNonPinnedEvents.forEach(ev => {
          if (idfosporttypes.indexOf(ev.idfosporttype) === -1) {
            idfosporttypes.push(ev.idfosporttype)
          }
        })

        return idfosporttypes
      },
      screenIdFoSports () {
        var sportnames = []
        this.cduNonPinnedEvents.forEach(ev => {
          if (sportnames.indexOf(ev.sportname) === -1) {
            sportnames.push(ev.sportname)
          }
        })

        return sportnames
      },
      liveEventAppearsOnScreen () {
        return this.cduNonPinnedEvents.filter(ev => ev.isliveevent && ev.idfobolifestate === 'O').length > 0
      }
    },

    methods: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import '~@/css/config'

  .cdu-header-component
    height: unit(header-height, px)
    margin-bottom: 15px
    display: flex
    align-items: center

    .logo
      margin-right: 40px
      max-height: 100%

      .browser-firefox &
        height: 50px

    .screen-message
      font-size 2.1rem
      color #fff

    .paging-index
      color #fff
      flex: 1
      text-align: right
      display none
</style>



// WEBPACK FOOTER //
// src/components/cdu/cduHeader.vue